import EventBase from './EventBase'
import EventID from './EventID'


/**
 * 204	按钮分歧
 */

export default class EventButtonDif extends EventBase {

  /**
   * 按钮分歧的构造函数
   */
  constructor(param: string[]) {
    super()
    this.Parameter = param
  }

  /**
   * 剧情ID
   */
  Code = EventID.ButtonDif

  /**
   * 选择项
   */
  get ButtonChoice() {
    const list = new Array<string>()
    if (this.Parameter) {
      list.push(...this.Parameter)
    }
    return list
  }
  set ButtonChoice(value) {
    this.Parameter = value

  }
  /**
   * 获取按钮选择项数组信息
   */
  GetButtonItem() {
    const list = new Array<string[]>()
    if (this.Parameter == null) {
      return list
    }
    this.Parameter.forEach((item) => {
      const pars = item.split(',')
      list.push(pars)
    })
    return list
  }

  /**
   * 设置按钮选择项数组信息
   */
  SetButtonItem(list: Array<string[]>) {
    if (!list || list.length == 0) return
    const listStr: Array<string> = new Array<string>()
    list.forEach((item) => {
      listStr.push(item[0] + ',' + item[1] + ',' + item[2])
    })
    this.ButtonChoice = listStr
  }

  /**
   * 获取显示信息
   */
}
